import { useEffect } from "react";
import { useForm } from "@inertiajs/react";
import { handleDrawerSuccess, hasArrayErrors } from "@/lib/drawer-submission";

function roleLabel(role = "") {
  return role.replace(/Role$/, "").replace(/([a-z])([A-Z])/g, "$1 $2");
}

export default function InvitationDrawerForm({
  submitPath,
  invitation = {},
  errors = [],
  currentTenant = null,
  organizations = [],
  roles = [],
  organizationLocked = false,
  onSuccess,
  onProcessingChange = null
}) {
  const initialEmail = invitation.email || "";
  const initialRole = invitation.role || roles[0] || "";
  const initialOrganizationId = invitation.organization_id || currentTenant?.id || organizations[0]?.id || "";
  const { data, setData, post, processing } = useForm({
    email: initialEmail,
    role: initialRole,
    organization_id: initialOrganizationId
  });

  useEffect(() => {
    setData({
      email: initialEmail,
      role: initialRole,
      organization_id: initialOrganizationId
    });
  }, [initialEmail, initialRole, initialOrganizationId]);

  useEffect(() => {
    onProcessingChange?.(processing);
  }, [onProcessingChange, processing]);

  const submit = async (event) => {
    event.preventDefault();
    post(submitPath, {
      preserveScroll: true,
      onSuccess: (page) => handleDrawerSuccess(
        page,
        (props) => props.show_create_invitation_drawer || hasArrayErrors(props, "create_errors"),
        onSuccess
      ),
    });
  };

  return (
    <form id="invitation-drawer-form" className="vstack gap-4" onSubmit={submit}>
      {errors.length > 0 ? (
        <div className="alert alert-danger mb-0">{errors.join(", ")}</div>
      ) : null}

      <div>
        <label className="form-label fw-semibold">E-mail</label>
        <input
          type="email"
          className="form-control"
          value={data.email}
          onChange={(event) => setData("email", event.target.value)}
          placeholder="navn@firma.dk"
          required
        />
      </div>

      <div>
        <label className="form-label fw-semibold">Rolle</label>
        <select
          className="form-select"
          value={data.role}
          onChange={(event) => setData("role", event.target.value)}
          required
        >
          <option value="" disabled>Vælg rolle</option>
          {roles.map((role) => (
            <option key={role} value={role}>
              {roleLabel(role)}
            </option>
          ))}
        </select>
      </div>

      {organizationLocked ? (
        <div className="workspace-admin-list__empty">
          <div className="workspace-admin-list__title">{currentTenant?.name || "Aktiv organisation"}</div>
          <div className="workspace-admin-list__meta">
            Brugeren bliver inviteret til den aktive organisation.
          </div>
        </div>
      ) : (
        <div>
          <label className="form-label fw-semibold">Organisation</label>
          <select
            className="form-select"
            value={data.organization_id}
            onChange={(event) => setData("organization_id", event.target.value)}
            required
          >
            <option value="" disabled>Vælg organisation</option>
            {organizations.map((organization) => (
              <option key={organization.id} value={organization.id}>
                {organization.name}
              </option>
            ))}
          </select>
        </div>
      )}

      <div className="d-flex justify-content-end">
        <button type="submit" className="btn btn-primary" disabled={processing}>
          {processing ? "Opretter..." : "Opret bruger"}
        </button>
      </div>
    </form>
  );
}
